module.exports = "/dist/roboto-latin-900.svg?e43f0ef2eed55dc9e390c5032255e6f4";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-roboto/files/roboto-latin-900.svg
// module id = 94
// module chunks = 0